import React, { useState } from 'react'
interface Props {
  src: string
  defaultSrc: string
  alt?: string
  className?: string
}

const LogoImage = ({ src, defaultSrc, alt = '', className }: Props) => {
  const [imageSrc, setImageSrc] = useState(src)
  return (
    <img
      src={imageSrc}
      alt={alt}
      className={className}
      onError={() => setImageSrc(defaultSrc)}
    />
  )
}

export default LogoImage
